import { render, staticRenderFns } from "./szjdDetail_homepage.vue?vue&type=template&id=f0f5ea1a&scoped=true&"
import script from "./szjdDetail_homepage.vue?vue&type=script&lang=js&"
export * from "./szjdDetail_homepage.vue?vue&type=script&lang=js&"
import style0 from "./szjdDetail_homepage.vue?vue&type=style&index=0&id=f0f5ea1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5ea1a",
  null
  
)

export default component.exports